// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fontSize from './assets/js/fontSize'
import 'babel-polyfill'

import 'sob-ui/lib/styles/index.css';
import 'som-ui/lib/styles/index.css';
import "./assets/css/base.css";
import "./assets/css/public.css";
import "../static/hammer-pic";
import "../static/hammer.min";

//大搜车vue组件配置

import SobUI from 'sob-ui'; // 记得在 webpack 中配置别名哦
import SomUI from 'som-ui';
import SomCarPicker from '@souche-ui/som-car-picker'; // 引入组件
import SomScrollPicker from '@souche-ui/som-scroll-prevented'; // 引入组件
import SomSelectorItem from '@souche-ui/som-selector-item'; // 引入组件
import SomCityPicker from '@souche-ui/som-city-picker'; // 引入组件
import { ToastPlugin, LoadingPlugin } from 'sob-ui';
import Tower from 'tower';
import VConsole from 'vconsole';


// 引入mint ui组件
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css'; // 引入toast提示
import lubanvV2 from  './lubanV2.js';
lubanvV2()
Vue.config.productionTip = false;
Vue.use(SobUI);//使用大搜车vue组件
Vue.use(SomUI);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.use(SomCarPicker);
Vue.use(SomScrollPicker);
Vue.use(SomSelectorItem);
Vue.use(SomCityPicker);

Vue.use(MintUI);
window.name='first';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});

if(process.env.NODE_ENV !== 'production'){
  // 非生产环境显示调试器
  new VConsole();
}



// WEBPACK FOOTER //
// ./src/main.js